import React from "react";
import tw from "twin.macro";

import "./style.css";

const Container = tw.div`hidden md:block`;

export default () => {
  return (
    <Container>
      <div class="socialbody">
        <ul>
          <li>
            <a href="#">
              <i class="fa fa-facebook" aria-hidden="true"></i>
              <span> - Facebook</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fa fa-twitter" aria-hidden="true"></i>
              <span> - Twitter</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fa fa-google-plus" aria-hidden="true"></i>
              <span> - Google</span>
            </a>
          </li>
          <li>
            <a href="#">
              <i class="fa fa-instagram" aria-hidden="true"></i>
              <span> -Instagram</span>
            </a>
          </li>
        </ul>
      </div>
    </Container>
  );
};
